import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  width: 90%;
  max-width: 900px;
  min-height: 100vh;
`;
